import LoginPage from "@pages/Auth/Login";
import LoginOTP from "@pages/Auth/LoginOTP";
import PasswordReset from "@pages/Auth/PasswordReset";
import ResetPasswordPage from "@pages/Auth/ResetPassword";
import SentEmail from "@pages/Auth/SentEmail";

export const PublicRoutes = [
	{ path: "/", name: "Login", component: <LoginPage /> },
	{ path: "/login", name: "Login", component: <LoginPage /> },
	{ path: "/login-otp/:token", name: "Login", component: <LoginOTP />},
	{
		path: "/reset-password",
		name: "ResetPassword",
		component: <PasswordReset />,
	},
	{
		path: "/auth/vendor/set-password",
		name: "PasswordReset",
		component: <ResetPasswordPage />,
	},
	{ path: "/sent-email", name: "SentEmail", component: <SentEmail /> },
];
